let yoNuncaPicante = [
    'Tuve relaciones sexuales en pedo.',
    'Le chupé los pies a alguien.',
    'Estuve con alguien menor de edad.',
    'Tuve relaciones sexuales en la cama de mis padres.',
    'Tuve relaciones sexuales con una persona mientras pensaba en otra.',
    'Tuve relaciones sexuales en el cuarto de mi hermano/a.',
    'Tuve relaciones sexuales en la facultad.',
    'Tuve sexo en la primera cita.',
    'Me filmé haciendo un pete.',
    'Mentí sobre ser virgen.',
    'Tuve relaciones sexuales sin preservativo.',
    'Pagué para mirar porno.',
    'Tuve sexo con más de una persona en el mismo día.',
    'Mandé nudes.',
    'Perdí mi virginidad en un lugar que no era la cama.',
    'Simulé un orgasmo.',
    'Mentí acerca de con cuantas personas estuve.',
    'Fantaseé con tener sexo con alguien de esta habitación.',
    'Estuve con alguien más de 15 años mayor',
    'Tuve un sueño que no se lo podría contar a nadie.',
    'Tuve sexo en otro país.',
    'Me hice la paja con una foto de Facebook/Instagram.',
    'Tomé la pastilla del día después.',
    'Probé merca.',
    'Masturbé/me masturbaron en la calle.',
    'Estuve con alguien más de cinco años menor.',
    'Practiqué/me practicaron sexo oral en un auto en movimiento.',
    'Fui a un telo.',
    'Usé disfraz erótico',
    'Mandé nudes a alguien desconocido.',
    'Me chaparía a alguien que está presente.',
    'Tuve sexo estando loco.',
    'Me consideré bueno en el sexo.',
    'Escuché gemir a un amigo.',
    'Acabé en menos de dos minutos.',
    'Practiqué/me practicaron sexo oral con una pastilla de menta en la boca.',
    'Tuve sexo anal',
    'Me excité con una caricia',
    'Tuve sexo con alguien que no vi nunca más',
    'Usé un juguete sexual.',
    'Me acabaron en el cuerpo.',
    'Lamí helado del cuerpo de alguien.',
    'Me excité leyendo un libro.',
    'Estuve con un profesor.',
    'Pagué por tener sexo.',
    'Squirtié o hice squirtiar a alguien.',
    'Recibí/di un chirlo mientras tenía relaciones sexuales.',
    'Me acabaron en la cara.',
    'Hice una pose del Kamasutra.',
    'Hice caca en la calle.',
    'Me depilé el culo.',
    'Tragué fluido vaginal.',
    'Acabé en menos de dos minutos.',
    'Escuché gemir a un amigo.',
    'Tuve relaciones sobre una mesa.',
    'Vi a mis padres desnudos.',
    'Me metieron un dedo en el culo.',
    'Tragué semen.',
    'Me metí el dedo en el culo.',
    'Probé mi propio semen.',
    'Tuve relaciones mientras una de las personas estaba indispuesta.',
    'Limpié semen con ropa.',
    'Tuve sexo en el piso al lado de la cama.',
    'Tuve sexo en la cocina.',
    'Me caí mientras tenía sexo.',
    'Tuve hemorroides.',
    'Me masturbé pensando en el padre o madre de un amigo/a.',
    'Grité el nombre de una persona mientras tenía sexo.',
    'Tuve una erección en una reunión importante.',
    'Fantaseé con la pareja de un amigo.',
    'Presté ropa interior.',
    'Me hice una paja grupal.',
    'Escuché a mis vecinos tener relaciones sexuales.',
    'Le escondí chats a mi pareja.',
    'Usé preservativos con sabor.',
    'Miré porno con mi pareja.',
    'Miré porno con mis amigos.',
    'Chapé con alguien desconocido.',
    'Me masturbé al lado de una persona dormida.',
    'Estuve con mi primo.',
    'Fui observado por un animal mientras tenía sexo.',
    'Tuve sexo sin cuidarme.',
    'Miré porno.',
    'Tuve sexo en un lugar público.',
    'Tuve sexo en un auto.',
    'Tuve sexo frente a un espejo.',
    'Acabé con la ropa puesta.',
    'Usé ropa interior del sexo opuesto.',
    'Hice un striptease.',
    'Estuve con alguien que conocí online.',
    'Tuve sexo con las medias puestas.',
    'Toqué tetas hechas.',
    'Hice un trío.',
    'Fantaseé con hacer un trío.',
    'Tuve sexo en el baño.',
    'Tuve fantasías con alguien vestido de militar/policía/etc.',
    'Tuve semen en la boca.',
    'Estuve con alguien de mi mismo sexo.',
    'Usé el método de acabar afuera.',
    'Use un objeto común y corriente como juguete sexual.',
    'Me atraparon teniendo sexo.',
    'Fantaseé con un dibujito.',
    'Me dormí teniendo sexo.',
    'Toqué a mi pareja en el cine.',
    'Me masturbé.',
    'Me masturbé más de tres veces en el mismo día.',
    'Sexteé.',
    'Sentí vergüenza después de estar con alguien.',
    'Estuve en pleno acto y se me rompió el preservativo.',
    'Me duché con un amigo.',
    'Vi a mi vecino desnudo.',
    'Tuve un orgasmo.',
    'Tuve una enfermedad de transmisión sexual.',
    'Vi a alguno de mis abuelos desnudos.',
    'Olí la ropa interior de mi pareja.',
    'Tuve sexo en una cama cucheta.',
    'Tuve relaciones sexuales con alguien que no ví nunca más.',
    'Olí ropa interior ajena.',
    'Compré preservativos.',
    'Tuve sexo en las escaleras.',
    'Me masturbaron en la calle.',
    'Me até para tener relaciones sexuales.',
    'Tuve un sueño mojado.',
    'Tuve sexo con alguien que no habla mi idioma.',
    'Tuve un amante.',
    'Escuché a mis padres teniendo sexo.',
    'Dormí desnudo.',
    'Le puso sobrenombre a mis genitales.',
    'Me hice un test de embarazo.',
    'Me interrumpieron masturbándome.',
    'Me masturbé delante de mi pareja.',
    'Me quedé sin tener relaciones sexuales por no tener un preservativo encima.',
    'Vi hentai.',
    'Estuve con más de 10 personas en mi vida.',
]

export default yoNuncaPicante